import {
  FloatingFormItem,
  Group,
  PlanAccountsSelect,
} from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  DREFormValues,
  DREQuestReportType,
} from '@/core/domain/questReport/Reports/DRE/DRE.type';
import {
  Checkbox,
  Col,
  Form,
  FormInstance,
  Radio,
  Row,
  Tooltip,
  Typography,
} from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import FinancialDreMoreOptions from './FinancialDreMoreOptions';
import { Info } from 'react-feather';

interface Props {
  form: FormInstance<DREFormValues>;
}

const FinancialDreForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const dreQuestReportType = Form.useWatch('dreQuestReportType', form);

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields form={form} />

      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Title level={5} style={{ marginBottom: 0 }}>
            <Tooltip
              title={
                <>
                  <p>
                    <strong>Padrão:</strong> Mostra comparativamente os
                    resultados financeiros por caixa (valores movimentados) e
                    por competência (valores do período)
                  </p>
                  <p>
                    <strong>Competência:</strong> Exibe apenas o resultado
                    contábil, considerando receitas/despesas no período de
                    ocorrência, independente de pagamentos
                  </p>
                </>
              }
            >
              <Group gap={10}>
                Selecione o tipo de relatório
                <Info size={20} />
              </Group>
            </Tooltip>
          </Title>

          <FloatingFormItem
            name="dreQuestReportType"
            noStyle
            initialValue={DREQuestReportType.default}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio.Button value={DREQuestReportType.default}>
                Padrão
              </Radio.Button>
              <Radio.Button value={DREQuestReportType.competence}>
                Competência
              </Radio.Button>
            </Radio.Group>
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <Form.Item name="groupPlanAccounts" valuePropName="checked" noStyle>
            <Checkbox>Agrupar plano de contas</Checkbox>
          </Form.Item>
        </Col>

        {dreQuestReportType === DREQuestReportType.default && (
          <Col span={12}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'financial.dre.form.planAccount',
              })}
              name="planAccountIds"
            >
              <PlanAccountsSelect allowClear mode="multiple" />
            </FloatingFormItem>
          </Col>
        )}
      </Row>

      <FinancialDreMoreOptions />
    </Form>
  );
};

export default FinancialDreForm;
